import {
  ApplicationConfig,
  provideZoneChangeDetection,
  APP_INITIALIZER,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';

import { routes } from './app.routes';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from './shared/services/auth/authentication.service';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([errorInterceptor])),
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      // useFactory: (auth: AuthenticationService) => () =>
      //   firstValueFrom(fromPromise(auth.checkSession())),
      useFactory: (auth: AuthenticationService) => () => {
        auth.checkSession();
      },
      deps: [AuthenticationService],
      multi: true,
    },
    provideCharts(withDefaultRegisterables())
  ],
};
